import { dictionary } from "@dcc/lookup/dictionary/dictionary";

export const getYourGoalText = () => dictionary.DCC_Results_YourGoal;
export const getYouNowText = () => dictionary.DCC_Results_YouNow;
